<template>
  <div class="dash-widget-group">
    <ul>
      <li>
        <div class="card">
          <div class="card-body">
            <div class="dash-widget-header">
              <span class="dash-widget-icon">
                <img src="@/assets/admin_img/icon/widget-icon-01.svg" alt="icon" />
              </span>
              <div class="dash-count">
                <h6 class="count-title">User</h6>
                <h5 class="count">
                  <vue3-autocounter
                    class="counter-up"
                    ref="counter"
                    :startAmount="0"
                    :delay="3"
                    :endAmount="2563"
                    :duration="2"
                    separator=","
                    :autoinit="true"
                  />
                </h5>
              </div>
            </div>
          </div>
        </div>
      </li>
      <li>
        <div class="card">
          <div class="card-body">
            <div class="dash-widget-header">
              <span class="dash-widget-icon">
                <img src="@/assets/admin_img/icon/widget-icon-02.svg" alt="icon" />
              </span>
              <div class="dash-count">
                <h6 class="count-title">Video Calls</h6>
                <h5 class="count">
                  <vue3-autocounter
                    class="counter-up"
                    ref="counter"
                    :startAmount="0"
                    :delay="3"
                    :endAmount="6568"
                    :duration="2"
                    separator=","
                    :autoinit="true"
                  />
                </h5>
              </div>
            </div>
          </div>
        </div>
      </li>
      <li>
        <div class="card">
          <div class="card-body">
            <div class="dash-widget-header">
              <span class="dash-widget-icon">
                <img src="@/assets/admin_img/icon/widget-icon-03.svg" alt="icon" />
              </span>
              <div class="dash-count">
                <h6 class="count-title">Public Groups</h6>
                <h5 class="count">
                  <vue3-autocounter
                    class="counter-up"
                    ref="counter"
                    :startAmount="0"
                    :delay="3"
                    :endAmount="487"
                    :duration="2"
                    separator=","
                    :autoinit="true"
                  />
                </h5>
              </div>
            </div>
          </div>
        </div>
      </li>
      <li>
        <div class="card">
          <div class="card-body">
            <div class="dash-widget-header">
              <span class="dash-widget-icon">
                <img src="@/assets/admin_img/icon/widget-icon-04.svg" alt="icon" />
              </span>
              <div class="dash-count">
                <h6 class="count-title">Chats</h6>
                <h5 class="count">
                  <vue3-autocounter
                    class="counter"
                    ref="counter"
                    :startAmount="0"
                    :delay="3"
                    :endAmount="2456"
                    :duration="2"
                    separator=","
                    :autoinit="true"
                  />
                </h5>
              </div>
            </div>
          </div>
        </div>
      </li>
      <li>
        <div class="card">
          <div class="card-body">
            <div class="dash-widget-header">
              <span class="dash-widget-icon">
                <img src="@/assets/admin_img/icon/widget-icon-05.svg" alt="icon" />
              </span>
              <div class="dash-count">
                <h6 class="count-title">Status</h6>
                <h5 class="count">
                  <vue3-autocounter
                    class="counter-up"
                    ref="counter"
                    :startAmount="0"
                    :delay="3"
                    :endAmount="1953"
                    :duration="2"
                    separator=","
                    :autoinit="true"
                  />
                </h5>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
